<template>
  <div style="display: flex">
    <div class="" style="flex: 2">
      <!-- one -->
      <div style="">
        <div class="met-tip-box-bg">
          <div class="met-tip-box-bg-one">
            <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701747283627.png" alt="" />
            <div>{{ powerInfo.powerMetRegion1Name ? powerInfo.powerMetRegion1Name : '空气温湿度' }}统计分析</div>
            <div style="display: none">
              {{ devItem.deviceAddr }}
            </div>
          </div>
          <div class="met-tip-box-bg-two" style="">
            <div class="">
              <i style="background: #ffffff"></i>
              {{ powerInfo.powerMetRegion1Name ? powerInfo.powerMetRegion1Name.split(',')[0] : '温度' }}
            </div>
            <div class="">
              <i style="background: #00feff"></i>
              {{ powerInfo.powerMetRegion1Name ? powerInfo.powerMetRegion1Name.split(',')[1] : '湿度' }}
            </div>
          </div>
        </div>
        <div class="cx-worms-bottom-data">
          <div id="mainOne" style="width: 100%; height: 157px"></div>
          <div class="cx-worms-bottom-data-left">
            <div class="cx-worms-bottom-data-box">
              <ul class="cx-worms-bottom-data-ul1">
                <li style="opacity: 0.1; background: transparent"></li>
                <li style="opacity: 0.2; background: transparent"></li>
                <li style="opacity: 0.3"></li>
                <li style="opacity: 0.4"></li>
                <li style="opacity: 0.5"></li>
                <li style="opacity: 0.6"></li>
                <li style="opacity: 0.7"></li>
                <li style="opacity: 0.8"></li>
                <li style="opacity: 0.9"></li>
                <li style="opacity: 1"></li>
              </ul>
              {{ powerInfo.powerMetRegion1Name ? powerInfo.powerMetRegion1Name.split(',')[0] : '温度' }}
            </div>
            <div class="cx-worms-bottom-data-box">
              <ul class="cx-worms-bottom-data-ul2">
                <li style="opacity: 0.1"></li>
                <li style="opacity: 0.2"></li>
                <li style="opacity: 0.3"></li>
                <li style="opacity: 0.4"></li>
                <li style="opacity: 0.5"></li>
                <li style="opacity: 0.6"></li>
                <li style="opacity: 0.7"></li>
                <li style="opacity: 0.8"></li>
                <li style="opacity: 0.9"></li>
                <li style="opacity: 1"></li>
              </ul>
               {{ powerInfo.powerMetRegion1Name ? powerInfo.powerMetRegion1Name.split(',')[1] : '湿度' }}
            </div>
          </div>
        </div>
      </div>
      <!-- one end -->
      <!-- two -->
      <div style="margin-top: 10px">
        <div class="met-tip-box-bg">
          <div class="met-tip-box-bg-one">
            <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701747283627.png" alt="" />
            <div>{{ powerInfo.powerMetRegion2Name ? powerInfo.powerMetRegion2Name : '土壤温湿度' }}统计分析</div>
          </div>
          <div class="met-tip-box-bg-two" style="">
            <div class="">
              <i style="background: #ffffff"></i>
               {{ powerInfo.powerMetRegion2Name ? powerInfo.powerMetRegion2Name.split(',')[0] : '温度' }}
            </div>
            <div class="">
              <i style="background: #00feff"></i>
              {{ powerInfo.powerMetRegion2Name ? powerInfo.powerMetRegion2Name.split(',')[1] : '湿度' }}
            </div>
          </div>
        </div>
        <div class="cx-worms-bottom-data">
          <div id="mainTwo" style="width: 100%; height: 157px"></div>
          <div class="cx-worms-bottom-data-left">
            <div class="cx-worms-bottom-data-box">
              <ul class="cx-worms-bottom-data-ul1">
                <li style="opacity: 0.1; background: transparent"></li>
                <li style="opacity: 0.2; background: transparent"></li>
                <li style="opacity: 0.3"></li>
                <li style="opacity: 0.4"></li>
                <li style="opacity: 0.5"></li>
                <li style="opacity: 0.6"></li>
                <li style="opacity: 0.7"></li>
                <li style="opacity: 0.8"></li>
                <li style="opacity: 0.9"></li>
                <li style="opacity: 1"></li>
              </ul>
              {{ powerInfo.powerMetRegion2Name ? powerInfo.powerMetRegion2Name.split(',')[0] : '温度' }}
            </div>
            <div class="cx-worms-bottom-data-box">
              <ul class="cx-worms-bottom-data-ul2">
                <li style="opacity: 0.1"></li>
                <li style="opacity: 0.2"></li>
                <li style="opacity: 0.3"></li>
                <li style="opacity: 0.4"></li>
                <li style="opacity: 0.5"></li>
                <li style="opacity: 0.6"></li>
                <li style="opacity: 0.7"></li>
                <li style="opacity: 0.8"></li>
                <li style="opacity: 0.9"></li>
                <li style="opacity: 1"></li>
              </ul>
               {{ powerInfo.powerMetRegion2Name ? powerInfo.powerMetRegion2Name.split(',')[1] : '湿度' }}
            </div>
          </div>
        </div>
      </div>
      <!-- two end -->
      <div style="display: flex; margin-top: 30px">
        <div style="flex: 1">
          <div id="mainThree" style="width: 100%; height: 210px"></div>
        </div>
        <div style="flex: 1">
          <div id="mainFour" style="width: 100%; height: 210px"></div>
        </div>
      </div>
      <div style="display: flex; margin-top: 10px">
        <div style="flex: 1">
          <div id="mainFive" style="width: 100%; height: 210px"></div>
        </div>
        <div style="flex: 1">
          <div id="mainSix" style="width: 100%; height: 210px"></div>
        </div>
      </div>
    </div>
    <div class="" style="flex: 1; display: flex; justify-content: flex-end">
      <div style="width: 90%">
        <div class="cx-warm-right-item">
          <div class="cx-warm-right-top">
            <div class="cx-warm-right-img">
              <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701744536550.png" alt="" />
            </div>
            <div class="cx-warm-right-text">
              <p>实时气象</p>
              <p>气象采集数据</p>
            </div>
            <div class="cx-warm-right-hr"></div>
          </div>
          <div class="cx-warm-data-body">
            <div v-if="realTimeDataList.length == 0">
              <el-empty :image-size="75" description="暂无设备"
                image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"></el-empty>
            </div>
            <div v-else style="
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              ">
              <div class="cx-warm-data-list" style="display: flex" v-for="(item, index) in realTimeDataList"
                :key="index">
                <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701745944910.png" alt="" />
                <div v-if="item.nodeType == 1" class="cx-warm-data-text">
                  <p>{{ item.temValueStr }}{{ item.temUnit }}</p>
                  <p>{{ item.temName }}</p>
                </div>
                <div v-if="item.nodeType == 1" class="cx-warm-data-text">
                  <p>{{ item.humValueStr }}{{ item.humUnit }}</p>
                  <p>{{ item.humName }}</p>
                </div>
                <div v-if="item.nodeType == 2" class="cx-warm-data-text">
                  <p>{{ item.temValueStr }}{{ item.temUnit }}</p>
                  <p>{{ item.nodeName }}</p>
                </div>
                <div v-if="item.nodeType == 3" class="cx-warm-data-text">
                  <p>{{ item.humValueStr }}{{ item.humUnit }}</p>
                  <p>{{ item.nodeName }}</p>
                </div>
                <div v-if="item.nodeType > 3" style="display: flex">
                  <div v-if="item.nodeName == item.temName" class="cx-warm-data-text">
                    <p>{{ item.temValueStr }}{{ item.temUnit }}</p>
                    <p>{{ item.nodeName }}</p>
                  </div>
                  <div v-else class="cx-warm-data-text">
                    <p>{{ item.temValueStr }}{{ item.temUnit }}</p>
                    <p>{{ item.nodeName }}</p>
                  </div>
                  <div v-if="item.nodeName == item.humName" class="cx-warm-data-text">
                    <p>{{ item.humValueStr }}{{ item.humUnit }}</p>
                    <p>{{ item.nodeName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 5px">
          <div style="display: flex; justify-content: start">
            <div>
              <el-radio-group v-model="mapRadio" size="mini" @change="mapRadioOnChange()">
                <el-radio-button label="标准"></el-radio-button>
                <el-radio-button label="卫星"></el-radio-button>
                <el-radio-button label="3D"></el-radio-button>
                <el-radio-button label="室内"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="width: 40%">
              <el-input placeholder="请输入经纬度" v-model="mapLat" class="input-with-select" style="">
                <el-button slot="append" icon="el-icon-search" @click="searchMapLat()"></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div v-if="mapRadio == '标准'" style="margin-top: 5px">
          <el-radio-group v-model="mapRadioType" @change="mapRadioTypeOnChange()">
            <el-radio label="normal">标准</el-radio>
            <el-radio label="dark">幻影黑</el-radio>
            <el-radio label="light">月光银</el-radio>
            <el-radio label="whitesmoke">远山黛</el-radio>
            <el-radio label="fresh">草色青</el-radio>
            <el-radio label="grey">雅士灰</el-radio>
            <el-radio label="blue">靛青蓝</el-radio>
            <el-radio label="darkblue">极夜蓝</el-radio>
          </el-radio-group>
        </div>

        <div class="cx-warm-map" :style="mapRadio != '标准' ? 'height:460px' : ''" style="margin-top: 15px">
          <div id="container"></div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <span>当前设备暂无数据</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript"
  src="https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.CitySearch"></script>
<script>
import * as echarts from "echarts";
export default {
  name: "app",
  components: {},
  props: {
    // 当前活动tab的索引
    devItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mapLat: "",
      mapRadio: "标准",
      mapRadioType: "normal",
      sevenDay: [],
      echartList: [],
      oneChart: {},
      oneOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "cross",
          },
        },
        color: ["#ffffff", "#00FEFF"],
        grid: {
          left: "0%",
          right: "0%",
          top: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [0, 0, 0, 0, 0, 0, 0],
            boundaryGap: false,
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value} ℃",
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["#ffffff00", "#ffffff00"],
              },
            },
          },
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value} %RH",
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["#ffffff00", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "温度",
            type: "line",
            // stack: 'Total',
            // smooth: true,
            // areaStyle: {
            // 	backgroundColor: "rgba(255, 255, 255, 0.18)",
            // },
            emphasis: {
              focus: "series",
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " ℃";
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "湿度",
            type: "line",
            // stack: 'Total',
            // smooth: true,
            // areaStyle: {
            // 	backgroundColor: "rgba(136, 223, 242, 0.32)",
            // },
            yAxisIndex: 1,
            emphasis: {
              focus: "series",
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " %RH";
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      twoChart: {},
      twoOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "cross",
          },
        },
        color: ["#ffffff", "#00FEFF"],
        grid: {
          left: "0%",
          right: "0%",
          top: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [0, 0, 0, 0, 0, 0, 0],
            boundaryGap: false,
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value} " + " °C",
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["#ffffff00", "#ffffff00"],
              },
            },
          },
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value} %RH",
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["#ffffff00", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "温度",
            type: "line",
            // stack: 'Total',
            // smooth: true,
            // areaStyle: {
            // 	backgroundColor: "rgba(255, 255, 255, 0.18)",
            // },
            emphasis: {
              focus: "series",
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " °C";
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "湿度",
            type: "line",
            // stack: 'Total',
            // smooth: true,
            yAxisIndex: 1,
            // areaStyle: {
            // 	backgroundColor: "rgba(136, 223, 242, 0.32)",
            // },
            emphasis: {
              focus: "series",
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " %RH";
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      threeChart: {},
      threeOption: {
        title: {
          text: "光照度统计",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 20,
            fontWeight: 500,
            color: "#FFFFFF",
          },
        },
        visualMap: [
          {
            show: false,
            type: "continuous",
            dimension: 0,
            min: 0,
            max: 3,
            inRange: {
              color: ["rgba(0, 100, 251, 1)", "rgba(33, 228, 255, 1)"],
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "cross",
          },
        },
        color: ["rgba(24, 89, 255, 0.32)"],
        grid: {
          left: "3%",
          right: "8%",
          top: "30%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位:Lux",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["rgba(70, 90, 100, 0.67)", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            // showSymbol: false,
            data: [0, 0, 0, 0, 0, 0, 0],
            tooltip: {
              valueFormatter: function (value) {
                return value + " Lux";
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 2,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(24, 89, 255, 0.32)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(33, 228, 255, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
      fourChart: {},
      fourOption: {
        title: {
          text: "二氧化碳统计",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 20,
            fontWeight: 500,
            color: "#FFFFFF",
          },
        },
        visualMap: [
          {
            show: false,
            type: "continuous",
            dimension: 0,
            min: 0,
            max: 3,
            inRange: {
              color: ["rgba(0, 100, 251, 1)", "rgba(33, 228, 255, 1)"],
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "cross",
          },
        },
        color: ["rgba(24, 89, 255, 0.32)"],
        grid: {
          left: "3%",
          right: "8%",
          top: "30%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位:PPM",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["rgba(70, 90, 100, 0.67)", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            // showSymbol: false,
            data: [0, 0, 0, 0, 0, 0, 0],
            tooltip: {
              valueFormatter: function (value) {
                return value + " Lux";
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 2,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(24, 89, 255, 0.32)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(33, 228, 255, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
      fiveChart: {},
      fiveOption: {
        title: {
          text: "PH值统计",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 20,
            fontWeight: 500,
            color: "#FFFFFF",
          },
        },
        visualMap: [
          {
            show: false,
            type: "continuous",
            dimension: 0,
            min: 0,
            max: 3,
            inRange: {
              color: ["rgba(0, 100, 251, 1)", "rgba(33, 228, 255, 1)"],
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "cross",
          },
        },
        color: ["rgba(24, 89, 255, 0.32)"],
        grid: {
          left: "3%",
          right: "8%",
          top: "30%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["rgba(70, 90, 100, 0.67)", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            // showSymbol: false,
            data: [0, 0, 0, 0, 0, 0, 0],
            tooltip: {
              valueFormatter: function (value) {
                return value + " Lux";
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 2,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(24, 89, 255, 0.32)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(33, 228, 255, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
      sixChart: {},
      sixOption: {
        title: {
          text: "EC值统计",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 20,
            fontWeight: 500,
            color: "#FFFFFF",
          },
        },
        visualMap: [
          {
            show: false,
            type: "continuous",
            dimension: 0,
            min: 0,
            max: 3,
            inRange: {
              color: ["rgba(0, 100, 251, 1)", "rgba(33, 228, 255, 1)"],
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "cross",
          },
        },
        color: ["rgba(24, 89, 255, 0.32)"],
        grid: {
          left: "3%",
          right: "8%",
          top: "30%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位:MS/cm",
            axisLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["rgba(70, 90, 100, 0.67)", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            // showSymbol: false,
            data: [0, 0, 0, 0, 0, 0, 0],
            tooltip: {
              valueFormatter: function (value) {
                return value + " Lux";
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 2,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(24, 89, 255, 0.32)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(33, 228, 255, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
      map: {},
      oldDevItem: {
        devData: [],
      },
      realTimeDataList: [],
      loading: true,
      userInfo: {},
      centerDialogVisible: false,

      powerInfo:{}
    };
  },
  mounted() {
    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);

    let powerInfo = localStorage.getItem("power_info");
    this.powerInfo = JSON.parse(powerInfo); 
    console.log("this.powerInfo===================================",this.powerInfo)  

    console.log("气象组件---mounted", this.devItem);
    if (this.devItem.deviceAddr) {
      this.init();
    }
  },
  updated() {
    console.log("气象组件---更新数据重新渲染DOM", this.devItem);
    this.init();
  },
  beforeDestroy() {
    // console.log('气象组件---在实例销毁之前调用')
    this.oneChart.dispose();
    this.twoChart.dispose();
    this.threeChart.dispose();
    this.fourChart.dispose();
    this.fiveChart.dispose();
    this.sixChart.dispose();
    this.map.options && this.map.destroy();
  },
  methods: {
    init() {

             
      var region1 = this.powerInfo.powerMetRegion1Unit.split(",");
      var region1Name = this.powerInfo.powerMetRegion1Name.split(",");
      var region2 = this.powerInfo.powerMetRegion2Unit.split(",");
      var region2Name = this.powerInfo.powerMetRegion2Name.split(",");
      var region3 = this.powerInfo.powerMetRegion3Unit.split(",");
      var region3Name = this.powerInfo.powerMetRegion3Name.split(",");
      var region4 = this.powerInfo.powerMetRegion4Unit.split(",");
      var region4Name = this.powerInfo.powerMetRegion4Name.split(",");
      var region5 = this.powerInfo.powerMetRegion5Unit.split(",");
      var region5Name = this.powerInfo.powerMetRegion5Name.split(",");
      var region6 = this.powerInfo.powerMetRegion6Unit.split(",");
      var region6Name = this.powerInfo.powerMetRegion6Name.split(",");
      
    
      this.oneOption.yAxis[0].axisLabel.formatter = function (value) {
        return value + region1[0];
      };
      this.oneOption.series[0].name=region1Name[0];


      this.oneOption.yAxis[1].axisLabel.formatter = function (value) {
        return value + region1[1];
      };
      this.oneOption.series[1].name=region1Name[1];
      this.twoOption.yAxis[0].axisLabel.formatter = function (value) {
        return value + region2[0];
      };
      this.twoOption.series[0].name=region2Name[0];
      this.twoOption.yAxis[1].axisLabel.formatter = function (value) {
        return value + region2[1];
      };
      this.twoOption.series[1].name=region2Name[1];


      this.threeOption.yAxis[0].name="单位："+region3[0];
      this.threeOption.title.text= region3Name[0];
      this.fourOption.yAxis[0].name="单位："+region4[0];
      this.fourOption.title.text= region4Name[0];
      this.fiveOption.yAxis[0].name="单位："+region5[0];
      this.fiveOption.title.text= region5Name[0];
      this.sixOption.yAxis[0].name="单位："+region6[0];
      this.sixOption.title.text= region6Name[0];

      if (this.oldDevItem.deviceAddr != this.devItem.deviceAddr) {
        console.log("气象组件init=============================");

        if (this.oneChart.id) {
          this.oneChart.dispose();
          this.oneChart = {};
        }
        if (this.twoChart.id) {
          this.twoChart.dispose();
          this.twoChart = {};
        }
        if (this.threeChart.id) {
          this.threeChart.dispose();
          this.threeChart = {};
        }
        if (this.fourChart.id) {
          this.fourChart.dispose();
          this.fourChart = {};
        }
        if (this.fiveChart.id) {
          this.fiveChart.dispose();
          this.fiveChart = {};
        }
        if (this.sixChart.id) {
          this.sixChart.dispose();
          this.sixChart = {};
        }

        this.loading = true;
        this.getSevenDay();
        this.realTimeDataList = [];
        this.getRealTimeData();
        this.oldDevItem = this.devItem;
      } else {
        console.log("气象组件init重复======================");
      }
    },
    getRealTimeData() {
      //设备数据
      let httpData = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
        deviceAddrs: this.devItem.deviceAddr, //"0412230001",
      };
      this.$axios
        .get("/FourEmotions/getRealTimeData", {
          params: httpData,
        })
        .then((res) => {
          console.log("getRealTimeData气象设备数据-res===", res);
          if (res.data.length != 0) {
            this.realTimeDataList = res.data[0].data;
          } else {
            this.centerDialogVisible = true;
          }
        })
        .catch((error) => {
          console.log("getRealTimeData设备数据-error===", error);
          if (
            error.msg ==
            "运行时异常:syntax error, pos 1, line 1, column 2访问过于频繁"
          ) {
            this.$message.error("访问过于频繁");
          }
        });
    },
    /* 获取设备实时数据 */
    // getGasDataDetail() {
    // 	let httpData = {
    // 		deptId: that.vuex_user.deptId, //101,
    // 		deviceAddrs: that.deviceItem.deviceAddr //'40160490' //
    // 	};
    // 	that.$u.get('/api/FourEmotions/getRealTimeData', httpData).then((res) => {
    // 		console.log('气象res---', res);
    // 		if (res.length == 0) {
    // 			return uni.showModal({
    // 				title: '',
    // 				showCancel: false,
    // 				content: '设备暂未数据',
    // 				success: function(res) {
    // 					if (res.confirm) {
    // 						uni.navigateBack()
    // 					}
    // 				}
    // 			});
    // 		}
    // 		that.gasDataDetail = res[0];
    // 		that.loading = false;
    // 		uni.hideLoading()
    // 	}).catch((error) => {
    // 		console.log('气象error---', error);
    // 		that.loading = false;
    // 	});
    // },
    getSevenDay() {
      var dates = [];
      for (var i = 6; i >= 0; i--) {
        var date = new Date();
        console.log("date=======", date);
        date.setDate(date.getDate() - i);
        // var year = date.getFullYear();
        // var month = (date.getMonth() + 1).toString().padStart(2, "0");
        // var day = date.getDate().toString().padStart(2, "0");
        var hour = date.getHours().toString().padStart(2, "0");
        var minute = date.getMinutes().toString().padStart(2, "0");
        // var formattedDate = `${year}-${month}-${day}`;
        var formattedDate = `${hour}:${minute}`;
        dates.push(formattedDate);
      }
      this.sevenDay = dates;
      // console.log('getSevenDay', dates);
      this.initAllEchart();
    },
    getToDay() {
      var date = new Date();
      console.log("date=======", date);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var day = (date.getDate() + 1).toString().padStart(2, "0");
      var formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    initAllEchart() {
      console.time("初始化所有Echart---");
      this.oneChart = echarts.init(document.getElementById("mainOne"));
      this.oneOption.xAxis[0].data = this.sevenDay;
      this.oneChart.setOption(this.oneOption);

      this.twoChart = echarts.init(document.getElementById("mainTwo"));
      this.twoOption.xAxis[0].data = this.sevenDay;
      this.twoChart.setOption(this.twoOption);

      this.threeChart = echarts.init(document.getElementById("mainThree"));
      this.threeOption.xAxis[0].data = this.sevenDay;
      this.threeChart.setOption(this.threeOption);

      this.fourChart = echarts.init(document.getElementById("mainFour"));
      this.fourOption.xAxis[0].data = this.sevenDay;
      this.fourChart.setOption(this.fourOption);

      this.fiveChart = echarts.init(document.getElementById("mainFive"));
      this.fiveOption.xAxis[0].data = this.sevenDay;
      this.fiveChart.setOption(this.fiveOption);

      this.sixChart = echarts.init(document.getElementById("mainSix"));
      this.sixOption.xAxis[0].data = this.sevenDay;
      this.sixChart.setOption(this.sixOption);

      console.timeEnd("初始化所有Echart---");

      this.getEchart();
      this.map.options && this.map.destroy();
      this.map = {};
      this.newMap();
    },
    moveLastElementToFirst(arr) {
      let lastElement = arr.pop(); // 存储最后一位到临时变量
      arr.unshift(lastElement); // 将临时变量中的值放到数组的第一位
      return arr;
    },
    getEchart() {
      console.log("=========getEchart=========");

      let httpData = {
        seachType: 0,
        time: this.getToDay(),
        deviceAddr: this.devItem.deviceAddr, //'40160490' //设备ID
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      this.$axios
        .get("/FourEmotions", {
          params: httpData,
        })
        .then((ress) => {
          console.log("气象组件---getEchart-res===", ress);
          if (ress.data && ress.data.length != 0) {
            let res = ress.data;

            var dateTime = new Date();
            var getHoursTime = dateTime.getHours().toString().padStart(2, "0");
            console.time("hour---===========================", getHoursTime);

            for (let i in res) {
              let array = {};
              let xData = [];
              let yData = [];
              array.name = Object.keys(res[i])[0].split(",")[0];
              array.uni =
                Object.keys(res[i])[0].split(",")[1] == "null"
                  ? ""
                  : Object.keys(res[i])[0].split(",")[1];
              array.res = Object.values(res[i])[0];
              for (let j in array.res) {
                let xDataHour = array.res[j].x.substring(
                  array.res[j].x.length - 5,
                  array.res[j].x.length
                );
                if (xDataHour.substring(0,2) <= getHoursTime) {
                  xData.push(xDataHour);
                  yData.push(array.res[j].y);
                }
              }
              array.xData = this.moveLastElementToFirst(xData);
              array.yData = yData;


              /* one */
              if (array.name.includes(this.powerInfo.powerMetRegion1Name.split(",")[0])) {
                this.oneEchart1(array);
              }
              if (array.name.includes(this.powerInfo.powerMetRegion1Name.split(",")[1])) {
                this.oneEchart2(array);
              }
              /* one End */

              /* two */
              if (array.name.includes(this.powerInfo.powerMetRegion2Name.split(",")[0])) {
                this.twoEchart1(array);
              }
              if (array.name.includes(this.powerInfo.powerMetRegion2Name.split(",")[1])) {
                this.twoEchart2(array);
              }
              /* two End */

              /* three */
              if (array.name.includes(this.powerInfo.powerMetRegion3Name)) {
                this.threeEchart(array);
              }
              /* three End */

              /* four */
              if (
                array.name.includes(this.powerInfo.powerMetRegion4Name) 
                // ||array.name.includes("二氧化碳")
              ) {
                this.fourEchart(array);
              }
              /* four End */

              /* five */
              if (array.name.includes(this.powerInfo.powerMetRegion5Name)) {
                this.fiveEchart(array);
              }
              /* five End */

              /* six */
              if (array.name.includes(this.powerInfo.powerMetRegion6Name)) {
                this.sixEchart(array);
              }
              /* six End */
            }
          } else {
            /* 统计图没数据加载默认 */
            let array = {};
            let xData = [];
            let yData = [];
            array.xData = this.oneOption.xAxis[0].data = this.sevenDay;
            array.yData = [0, 0, 0, 0, 0, 0, 0];
            this.oneEchart1(array);
            this.oneEchart2(array);
            this.twoEchart1(array);
            this.twoEchart2(array);
            this.threeEchart(array);
            this.fourEchart(array);
            this.fiveEchart(array);
            this.sixEchart(array);
          }
        })
        .catch((error) => {
          console.log("气象组件---getEchart-error===", error);
        });
    },
    oneEchart1(array) {
      console.log("空气温度--oneEchart1--", array);
      this.oneOption.xAxis[0].data = array.xData;
      this.oneOption.series[0].data = array.yData;
      
      this.oneChart.setOption(this.oneOption);
    },
    oneEchart2(array) {
      console.log("空气湿度--oneEchart2--", array);
      this.oneOption.xAxis[0].data = array.xData;
      this.oneOption.series[1].data = array.yData;
      
      this.oneChart.setOption(this.oneOption);
    },
    twoEchart1(array) {
      console.log("土壤温度--twoEchart1--", array);
      console.log("this.powerInfo", this.powerInfo);
      this.twoOption.xAxis[0].data = array.xData;
      this.twoOption.series[0].data = array.yData;

     
      this.twoChart.setOption(this.twoOption);
    },
    twoEchart2(array) {
      console.log("土壤湿度--twoEchart2--", array);
      this.twoOption.xAxis[0].data = array.xData;
      this.twoOption.series[1].data = array.yData;
       
     
      this.twoChart.setOption(this.twoOption);
    },
    threeEchart(array) {
      console.log("光照度--threeEchart--", array);
      this.threeOption.xAxis[0].data = array.xData;
      this.threeOption.series[0].data = array.yData;
       
      this.threeChart.setOption(this.threeOption);
    },
    fourEchart(array) {
      console.log("二氧化碳--fourEchart--", array);
      this.fourOption.xAxis[0].data = array.xData;
      this.fourOption.series[0].data = array.yData;
      
      this.fourChart.setOption(this.fourOption);
    },
    fiveEchart(array) {
      console.log("PH值--fiveEchart--", array);
      this.fiveOption.xAxis[0].data = array.xData;
      this.fiveOption.series[0].data = array.yData;
      
      this.fiveChart.setOption(this.fiveOption);
    },
    sixEchart(array) {
      console.log("EC值--sixEchart--", array);
      this.sixOption.xAxis[0].data = array.xData;
      this.sixOption.series[0].data = array.yData;
      
      this.sixChart.setOption(this.sixOption);
    },
    mapRadioOnChange() {
      this.newMap();
      this.mapRadioType = "normal";
    },
    mapRadioTypeOnChange() {
      console.log("--mapRadioTypeOnChange--", this.mapRadioType);
      var styleName = "amap://styles/" + this.mapRadioType;
      this.map.setMapStyle(styleName);
    },
    searchMapLat() {
      this.newMap();
      this.mapRadioType = "normal";
    },
    newMap() {
      console.log(this.mapRadio);
      let lngLat = this.mapLat != "" ? this.mapLat.split(",") : [];

      if (lngLat.length > 0) {
        lngLat.push(lngLat[0]);
        lngLat.push(lngLat[1]);
      }
      let scripts = [];
      if (this.mapRadio == "标准") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6",
          "https://cache.amap.com/lbs/static/es5.min.js",
        ];
      } else if (this.mapRadio == "卫星") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=Map3D",
        ];
      } else if (this.mapRadio == "3D") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ControlBar",
        ];
      } else if (this.mapRadio == "室内") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ToolBar",
          "https://webapi.amap.com/demos/js/liteToolbar.js",
        ];
      }

      scripts.forEach((src) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
          // 外部 JS 文件加载成功后的回调函数
          // console.log('气象newMap加载成功');

          // 这是中心点的经纬度
          // 业务中应该是获取当前位置
          if (this.mapRadio == "标准") {
            this.map = new AMap.Map("container", {
              resizeEnable: true, //是否监控地图容器尺寸变化
              mapStyle: "amap://styles/fresh",
              zoom: this.mapLat != "" ? 6 : 13, //初始化地图层级
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
            });
          } else if (this.mapRadio == "卫星") {
            this.map = new AMap.Map("container", {
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 13, //初始化地图层级
              mapStyle: "amap://styles/fresh",
              features: ["road", "bg"],
            });

            let satellite = new AMap.TileLayer.Satellite({
              map: this.map,
            });
          } else if (this.mapRadio == "3D") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              rotateEnable: true,
              pitchEnable: true,
              zoom: this.mapLat != "" ? 14 : 17, //初始化地图层级
              pitch: 80,
              rotation: -15,
              viewMode: "3D", //开启3D视图,默认为关闭
              buildingAnimation: true, //楼块出现是否带动画

              expandZoomRange: true,
              zooms: [3, 20],
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
            });

            this.map.addControl(
              new AMap.ControlBar({
                showZoomBar: false,
                showControlButton: true,
                position: {
                  right: "10px",
                  top: "10px",
                },
              })
            );
          } else if (this.mapRadio == "室内") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 18, //初始化地图层级
              pitch: 50,
              viewMode: "3D",
            });

            this.map.on("indoor_create", function () {
              this.map.indoorMap.showIndoorMap("B000A856LJ", 5);
            });
          }

          if (lngLat.length > 0) {
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              "" +
              '<div class="custom-content-marker">' +
              '   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705998876110.gif">' +
              "</div>";
            let lngLons = lngLat[0];
            let lngLats = lngLat[1];
            const position = new AMap.LngLat(lngLons, lngLats); // Marker经纬度
            const marker = new AMap.Marker({
              position: position,
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
            });
            this.map.add(marker);
          }else{
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              "" +
              '<div class="custom-content-marker">' +
              '   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705998876110.gif">' +
              "</div>";
            let lngLons = this.devItem.devicelng;
            let lngLats = this.devItem.devicelat;
            const position = new AMap.LngLat(lngLons, lngLats); // Marker经纬度
            const marker = new AMap.Marker({
              position: position,
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
            });
            this.map.add(marker);
          }
          this.loading = false;
        };
        script.onerror = (err) => {
          // 外部 JS 文件加载失败后的回调函数
          // console.log('气象newMap加载失败', err);
          this.loading = false;
        };
        document.head.appendChild(script);
      });
    },
  },
};
</script>

<!-- <style>
	@import url("https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css");
</style> -->
<style>
.met-tip-box-bg {
  width: 100%;
  height: 44px;
  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701757063603.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 0 9px; */
}

.met-tip-box-bg img {
  width: 20px;
  height: 20px;
  margin-right: 7px;
}

.met-tip-box-bg-one {
  display: flex;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.met-tip-box-bg-two {
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.met-tip-box-bg-two div {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.met-tip-box-bg-two i {
  width: 15px;
  height: 2px;
  background: #ffffff;
  margin-right: 8px;
  display: inline-block;
}

.cx-worms-bottom-data-ul2 li {
  background: #00feff;
}

.cx-worms-bottom-data-ul1 li {
  background: #ffffff;
}

.cx-worms-bottom-data-box ul li {
  list-style: none;
  width: 26px;
  height: 11px;
}

.cx-worms-bottom-data-box ul {
  /* width: 36px; */
  height: 111px;
  border: 1px solid #808082;
  padding: 4px;
  margin-bottom: 5px;
}

.cx-worms-bottom-data-box {
  font-size: 12px;
  color: #fafafc;
}

.cx-worms-bottom-data-left {
  display: flex;
  width: 90px;
  justify-content: space-between;
  align-items: center;
}

.cx-worms-bottom-data {
  margin-top: 20px;
  display: flex;
}

.custom-content-marker {
  position: relative;
  width: 34px;
  height: 34px;
}

.custom-content-marker img {
  width: 100%;
  height: 100%;
}

#container {
  width: 100%;
  height: 100%;
}

/* 地图 */

.cx-warm-map {
  width: 100%;
  height: 400px;
}

.cx-warm-data-text p:first-child {
  font-size: 14px;
  padding: 3px 0 7px 0;
}

.cx-warm-data-text p {
  margin: 0;
}

.cx-warm-data-text {
  font-size: 12px;
  color: #ffffff;
  line-height: 16px;
  margin-right: 20px;
}

.cx-warm-data-list img {
  width: 48px;
  height: 48px;
  margin-right: 10px;
}

.cx-warm-data-list {
  margin-bottom: 15px;
  display: flex;
  width: 49%;
}

.cx-warm-data-body {
  height: 360px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  margin-top: 15px;
}

.cx-warm-data-body::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

.cx-warm-data-body::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.cx-warm-right-hr {
  width: 12px;
  height: 41px;
  border-bottom: 3px #18fefe solid;
  margin-left: 3px;
}

.cx-warm-right-text {
  line-height: 44px;
  border-bottom: 1px rgba(255, 255, 255, 0.5) solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 50px);
  height: 43px;
  font-size: 16px;
  font-weight: bold;
}

.cx-warm-right-img {
  width: 34px;
  border-bottom: 3px #fff solid;
  padding: 12px 0 9px 0;
  text-align: center;
}

.cx-warm-right-img img {
  width: 20px;
  height: 20px;
}

.cx-warm-right-top {
  width: 100%;
  height: 44px;
  display: flex;
}

.cx-warm-right-item {
  margin-bottom: 20px;
  width: 100%;
  height: 400px;
  background: rgba(0, 0, 0, 0.5);
  /* padding: 20px; */
}

.el-radio {
  margin-top: 15px;
}

.el-input-group>.el-input__inner {
  height: 29px;
  width: 93%;
  margin-left: 10px;
  font-size: 12px;
}
</style>
